/** Valentines Day Offer Images */
// Hero Banner
import valentinesDayHeroBanner from '../../../assets/ValentinesDayOffers/valentinesDayHeroBanner.webp';

import bgImage from '../../../assets/ValentinesDayOffers/bgImage.webp';

// categories
import food from '../../../assets/ValentinesDayOffers/categories/food.webp';
import travel from '../../../assets/ValentinesDayOffers/categories/travel.webp';
import shopping from '../../../assets/ValentinesDayOffers/categories/shopping.webp';
import electronics from '../../../assets/ValentinesDayOffers/categories/electronics.webp';
import entertainment from '../../../assets/ValentinesDayOffers/categories/entertainment.webp';

// spotlight brands
import spotlight_brand_1 from '../../../assets/ValentinesDayOffers/spotlightBrands/Swiggy.webp';
import spotlight_brand_2 from '../../../assets/ValentinesDayOffers/spotlightBrands/JioMart.webp';
import spotlight_brand_3 from '../../../assets/ValentinesDayOffers/spotlightBrands/Instamart.webp';
import spotlight_brand_4 from '../../../assets/ValentinesDayOffers/spotlightBrands/AbhiBus.webp';
import spotlight_brand_5 from '../../../assets/ValentinesDayOffers/spotlightBrands/Eatsure.webp';
import spotlight_brand_6 from '../../../assets/ValentinesDayOffers/spotlightBrands/Redbus.webp';
import spotlight_brand_7 from '../../../assets/ValentinesDayOffers/spotlightBrands/EMT.webp';
import spotlight_brand_8 from '../../../assets/ValentinesDayOffers/spotlightBrands/TheManCompany.webp';

// other Brands
import otherBrands_ConfirmTkt from '../../../assets/ValentinesDayOffers/otherBrands/ConfirmTkt.svg';
import otherBrands_BookMyShow from '../../../assets/ValentinesDayOffers/otherBrands/BookMyShow.svg';
import otherBrands_Neemans from '../../../assets/ValentinesDayOffers/otherBrands/Neemans.svg';
import otherBrands_Zeeraki from '../../../assets/ValentinesDayOffers/otherBrands/Zeeraki.svg';
import otherBrands_Netmeds from '../../../assets/ValentinesDayOffers/otherBrands/Netmeds.svg';
import otherBrands_JustHerbs from '../../../assets/ValentinesDayOffers/otherBrands/JustHerbsv2.svg';

// App Exclusive
import ssae_TwidStars from '../../../assets/ValentinesDayOffers/appExclusive/TwidStars.webp';
import ssae_TwidScanAndPay from '../../../assets/ValentinesDayOffers/appExclusive/TwidScanAndPay.webp';
import ssae_Ixigo from '../../../assets/ValentinesDayOffers/appExclusive/Ixigo.webp';

export default {
  bgImage,
  valentinesDayHeroBanner,
  categories: {
    food,
    travel,
    shopping,
    electronics,
    entertainment,
  },
  valentinesDaySpotlightBrands: {
    spotlight_brand_1,
    spotlight_brand_2,
    spotlight_brand_3,
    spotlight_brand_4,
    spotlight_brand_5,
    spotlight_brand_6,
    spotlight_brand_7,
    spotlight_brand_8,
  },
  valentinesDayOtherBrands: {
    otherBrands_ConfirmTkt,
    otherBrands_BookMyShow,
    otherBrands_Neemans,
    otherBrands_Zeeraki,
    otherBrands_Netmeds,
    otherBrands_JustHerbs,
  },
  valentinesDayAppExclusive: {
    ssae_TwidStars,
    ssae_TwidScanAndPay,
    ssae_Ixigo,
  },
};
